shadow$provide[297] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Slide:{enumerable:true, get:function() {
  return Slide;
}}});
var require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js = require("../base/parent.js");
class Slide extends require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js.Parent {
  static initClass() {
    this.traits = ["node", "slide", "visible", "active"];
  }
  make() {
    this._helpers.visible.make();
    this._helpers.active.make();
    if (!this._inherit("present")) {
      throw new Error(`${this.node.toString()} must be placed inside <present></present>`);
    }
    return this._inherit("present").adopt(this);
  }
  unmake() {
    this._helpers.visible.unmake();
    this._helpers.active.unmake();
    return this._inherit("present").unadopt(this);
  }
  change(changed, _touched, _init) {
    if (changed["slide.early"] || changed["slide.late"] || changed["slide.steps"] || changed["slide.from"] || changed["slide.to"]) {
      return this.rebuild();
    }
  }
  slideLatch(enabled, step) {
    this.trigger({type:"transition.latch", step:step,});
    if (enabled != null) {
      return this._instant(enabled);
    }
  }
  slideStep(index, step) {
    return this.trigger({type:"slide.step", index:index, step:step,});
  }
  slideRelease() {
    return this.trigger({type:"transition.release",});
  }
  slideReset() {
    this._instant(false);
    return this.trigger({type:"slide.reset",});
  }
  _instant(enabled) {
    this.setVisible(enabled);
    return this.setActive(enabled);
  }
}
Slide.initClass();

};